const STORAGE_KEY = 'visitorAuthToken';

class VisitorAuthTokenUtil {
  private authToken: string | null = null;

  constructor() {
    const authToken = localStorage.getItem(STORAGE_KEY);
    if (authToken) {
      this.authToken = authToken;
    }
  }

  set(token: string) {
    this.authToken = token;
    localStorage.setItem(STORAGE_KEY, token);
  }

  get() {
    return this.authToken;
  }

  remove() {
    this.authToken = null;
    localStorage.removeItem(STORAGE_KEY);
  }
}

export default new VisitorAuthTokenUtil();
